import { toast } from "react-toastify";

/**
 * Universal API Error Handler
 * Supports:
 * 1. { success:false, errors:[{ msg:"..." }] }
 * 2. { success:false, error:"Failed" }
 * 3. { error:"Failed" }
 * 4. "Failed"
 * 5. Axios / Fetch error objects
 */

export const showApiSuccessToast = (message) => {
  toast.success(message)
}
export const showApiErrorToast = (error) => {
  let message = "Something went wrong";

  // 1️⃣ String error
  if (typeof error === "string") {
    message = error;
  }

  // 2️⃣ Axios / Fetch error response
  else if (error?.response?.data) {
    const data = error.response.data;

    // errors array
    if (Array.isArray(data.errors) && data.errors?.length > 0) {
      message = data.errors[0].msg || message;
    }
    // error string
    else if (typeof data.error === "string") {
      message = data.error;
    }
    // message field
    else if (typeof data.message === "string") {
      message = data.message;
    }
  }

  // 3️⃣ Redux rejectWithValue payload
  else if (error?.errors && Array.isArray(error.errors)) {
    message = error.errors[0]?.msg || message;
  }

  // 4️⃣ Direct error field
  else if (typeof error?.error === "string") {
    message = error.error;
  }

  // 5️⃣ Fallback
  else if (typeof error?.message === "string") {
    message = error.message;
  }

  toast.error(message);
};
